import { hasValue } from "../../../utils/functions.js";

import TableList from "../../sub-components/Generic/TableList/TableList.vue";
import DateField from "../../common/date-field";

const methods = {
  TransactionMerchantName: function (data){
    return data.Merchant.Id == data.Transaction.Merchant.Id ? '-' : data.Transaction.Merchant.Name
  },
  TransactionMerchantIdentity: function (data){
    return data.Merchant.Id == data.Transaction.Merchant.Id ? '' : data.Transaction.Merchant.Identity
  },
  TransactionId: function (data){
    return data.Merchant.Id == data.Transaction.Merchant.Id ? '-' : data.Transaction.Id
  },
}

const fieldMerchant = [
  { field: "Merchant.Name", class: "text-left" },
  { field: "Merchant.Identity", type: 'identity', class: "identity text-left" }
];
const fieldTransactionMerchant = [
  { field: methods.TransactionMerchantName, class: "text-left" },
  { field: methods.TransactionMerchantIdentity, type: 'identity', class: "identity text-left" }
];

export default {
  name: "DoublePayment",
  components: {
    TableList,
    DateField
  },
  data() {
    return {
      headers: [
        { field: "Transaction.Merchant.Id", label: "ID do Cliente", classHeader: 'text-left', classField: 'text-left td-with-subs' },
        { field: fieldMerchant, label: "Nome do Cliente", classHeader: 'text-left', classField: 'text-left td-with-subs' },

        { field: methods.TransactionId, label: "ID da Transação" },
        { field: fieldTransactionMerchant, label: "Nome na Transação", classHeader: 'text-left', classField: 'text-left td-with-subs' },

        { field: "CheckingAccount.Amount", label: "Valor", type: "currency", classHeader: 'text-left', classField: 'text-left same-line' },
        //{ field: "CreatedDate", label: "Data de Criação", type: "date" },
        { field: "CheckingAccount.ReleaseDate", label: "Data do Repasse", type: "date" },
        { field: "CheckingAccount.IsTransferred", label: "Transferido", type: "YesNoIcon", classHeader: 'text-left' }
      ],
      pageName: 'Pagamentos Duplicados',
      permissionIsAuthorize: 'DoublePayment',
      modalTitle: "",
      countFilter: 0,
      itemList: [],
      filter: {
        IdMerchant: null,
        NameMerchant: null,
        IdentityMerchant: null,

        IdTransaction: null,
        IdTransactionyMerchant: null,
        NameTransactionMerchant: null,
        IdentityTransactionMerchant: null,

        IsTransferred: null,
        CreatedDateIni: null,
        CreatedDateFin: null,
        ReleaseDateIni: null,
        ReleaseDateFin: null
      },
      loading: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      }
    };
  },
  watch: {
    "filter.ReleaseDateIni"() {
      this.$forceUpdate();
    },
    "filter.ReleaseDateFin"() {
      this.$forceUpdate();
    }
  },
  mounted() {
    this.loading = true;
    this.ListDoublePayment();
  },

  methods: {
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListDoublePayment();
    },

    ResetFilter() {
      this.filter = {
        IdMerchant: null,
        NameMerchant: null,
        IdentityMerchant: null,

        IdTransaction: null,
        IdTransactionyMerchant: null,
        NameTransactionMerchant: null,
        IdentityTransactionMerchant: null,

        IsTransferred: null,
        CreatedDateIni: null,
        CreatedDateFin: null,
        ReleaseDateIni: null,
        ReleaseDateFin: null
      };
      this.ListDoublePayment();
    },

    SaveField() {
      this.validatedFormValidation = true;
      this.$refs.ValidationForm.validate().then(isValid => {
        if (isValid) {
          this.loading = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.AddCustomerService();
          }
        }
      });
    },

    GetParamsListDoublePayment(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Merchant.Id": this.filter.IdMerchant,
        "Object.Merchant.Name": this.filter.NameMerchant,
        "Object.Merchant.Identity": this.filter.IdentityMerchant,

        "Object.Transaction.Id": this.filter.IdTransaction,
        "Object.Transaction.Merchant.Id": this.filter.IdTransactionyMerchant,
        "Object.Transaction.Merchant.Name": this.filter.NameTransactionMerchant,
        "Object.Transaction.Merchant.Identity": this.filter.IdentityTransactionMerchant,

        "CreatedDateIni": this.filter.CreatedDateIni,
        "CreatedDateFin": this.filter.CreatedDateFin,
        "ReleaseDateIni": this.filter.ReleaseDateIni,
        "ReleaseDateFin": this.filter.ReleaseDateFin
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    GetDoublePayment() {
      if (this.idField != 0) {
        this.loading = true;
        this.$store.dispatch("GetDoublePayment", { id: this.idField })
          .then(response => {
            this.formField = response;
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao carregar o campo", "danger", "Erro ao carregar o campo", error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    ListDoublePayment() {
      this.loading = true;
      this.countFilter = 0;
      Object.values(this.filter).map(value => { if (hasValue(value)) this.countFilter++ });
      const params = this.GetParamsListDoublePayment();
      this.$store.dispatch("ListDoublePayment", { params: params })
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger", "Erro ao listar os Campos", error);
        })
        .finally(() => (this.loading = false));
    },

    GetReport() {
      this.loading = true;
      const params = this.GetParamsListDoublePayment(true);
      this.$store.dispatch("ReportDoublePayment", { params })
        .then(response => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loading = false;
          }, 1200);
        });
    },
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/DoublePayment/DoublePayment.js